// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"c0ce440c","188":"d36f641f","856":"3ae2710e"}[chunkId] + ".js";
};